function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "ic-computer_svg__a",
  width: "125%",
  height: "125%",
  x: "-12.5%",
  y: "-10.7%",
  filterUnits: "objectBoundingBox"
}, React.createElement("feMorphology", {
  "in": "SourceAlpha",
  operator: "dilate",
  radius: 1,
  result: "shadowSpreadOuter1"
}), React.createElement("feOffset", {
  dy: 2,
  "in": "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  "in": "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 4
}), React.createElement("feComposite", {
  "in": "shadowBlurOuter1",
  in2: "SourceAlpha",
  operator: "out",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  "in": "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
})), React.createElement("circle", {
  id: "ic-computer_svg__b",
  cx: 56,
  cy: 56,
  r: 56
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M0-2h130v130H0z"
}), React.createElement("g", {
  transform: "translate(9 7)"
}, React.createElement("use", {
  fill: "#000",
  filter: "url(#ic-computer_svg__a)",
  xlinkHref: "#ic-computer_svg__b"
}), React.createElement("use", {
  fill: "#FFF",
  stroke: "#12123B",
  strokeWidth: 2,
  xlinkHref: "#ic-computer_svg__b"
})), React.createElement("path", {
  d: "M29 27h72v72H29z"
}), React.createElement("path", {
  stroke: "#12123B",
  strokeWidth: 2,
  d: "M85.177 76.49H42.353a2.197 2.197 0 01-2.196-2.196V45.745c0-1.212.984-2.196 2.196-2.196h42.824c1.212 0 2.196.984 2.196 2.196v28.55a2.197 2.197 0 01-2.196 2.195z"
}), React.createElement("path", {
  stroke: "#12123B",
  strokeWidth: 2,
  d: "M81.877 71.994H45.653c-.61 0-1.103-.494-1.103-1.103V50.246c0-.61.494-1.103 1.103-1.103h36.224c.61 0 1.104.494 1.104 1.103v20.645c0 .609-.494 1.103-1.104 1.103z"
}), React.createElement("path", {
  fill: "#12123B",
  d: "M62.118 46.843h3.294v-1.098h-3.294z"
}), React.createElement("path", {
  stroke: "#12123B",
  strokeWidth: 2,
  d: "M89.909 82.53H37.62a1.856 1.856 0 01-1.856-1.856v-1.78c0-1.024.83-1.855 1.856-1.855h52.29c1.025 0 1.856.831 1.856 1.856v1.779c0 1.024-.83 1.855-1.856 1.855z"
}), React.createElement("path", {
  stroke: "#12123B",
  strokeWidth: 2,
  d: "M67.745 78.765h-8l-3.012-1.998h14.053z"
}), React.createElement("path", {
  fill: "#12123B",
  d: "M44 79.784h2.197v-1.098H44zm3.295 0h2.196v-1.098h-2.196z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M93.527 82.53H79.059a2.195 2.195 0 01-2.049-2.985l5.44-11.29v-9.882h7.686v9.882l5.441 11.29a2.196 2.196 0 01-2.05 2.984"
}), React.createElement("path", {
  stroke: "#12123B",
  strokeWidth: 2,
  d: "M93.527 82.53H79.059a2.195 2.195 0 01-2.049-2.985l5.44-11.29v-9.882h7.686v9.882l5.441 11.29a2.196 2.196 0 01-2.05 2.984z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M91.68 60.569H80.905a2.318 2.318 0 110-4.636H91.68a2.318 2.318 0 110 4.636"
}), React.createElement("path", {
  stroke: "#12123B",
  strokeWidth: 2,
  d: "M91.68 60.569H80.905a2.318 2.318 0 110-4.636H91.68a2.318 2.318 0 110 4.636z"
}), React.createElement("path", {
  fill: "#12123B",
  d: "M87.628 65.912a1.5 1.5 0 11-2.999.001 1.5 1.5 0 012.999-.001m1.098 5.49a1.5 1.5 0 11-2.999.001 1.5 1.5 0 012.999-.001m-1.098 5.49a1.5 1.5 0 11-2.999.002 1.5 1.5 0 012.999-.002"
}), React.createElement("g", {
  transform: "translate(14.49 8.098)"
}, React.createElement("circle", {
  cx: 13.176,
  cy: 13.176,
  r: 12.176,
  fill: "#FFF",
  stroke: "#12123B",
  strokeWidth: 2
}), React.createElement("path", {
  fill: "#12123B",
  d: "M16.368 17.257c.269 0 .47.061.605.185.134.123.201.296.201.52 0 .482-.269.723-.806.723h-5.611c-.55 0-.824-.241-.824-.723 0-.224.07-.397.21-.52.14-.124.345-.185.614-.185h1.932V8.874l-1.73 1.092a.648.648 0 01-.337.1c-.19 0-.355-.084-.495-.252a.868.868 0 01-.21-.57c0-.258.112-.46.336-.606l2.587-1.646c.257-.157.504-.235.739-.235a.82.82 0 01.605.235c.157.157.235.37.235.638v9.627h1.949z"
})));

var SvgIcComputer = function SvgIcComputer(props) {
  return React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,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";
export { SvgIcComputer as ReactComponent };